import gql from 'graphql-tag';

import listSettingFragment from '../fragments/listSettingFragment';

export const mutationUpdateListSetting = gql`
  mutation updateListSetting (
    $listKey: ID!
    $orderByColumn: ListSettingOrderByColumn
    $orderByDirection: ListSettingOrderByDirection
    $displayFormat: ListSettingDisplayFormat
    $density: ListSettingDensity
    $galleryScale: Float
    $columns: [ListSettingColumnInput!]
  ) {
    updateListSetting (
      listKey: $listKey
      orderByColumn: $orderByColumn
      orderByDirection: $orderByDirection
      displayFormat: $displayFormat
      density: $density
      galleryScale: $galleryScale
      columns: $columns
    ) {
      ...listSettingFragment
    }
  }
  ${listSettingFragment}
`;
export default mutationUpdateListSetting;
